import _ from 'underscore';
import Backbone from 'backbone';
import BaseView from './base-view';
import ProjectUtil from '../utils/project-util';
import LoaderView from './loader';
import gsap from 'gsap';

class BaseFilterView extends BaseView {

	constructor(options = {}) {
		super(options);
		//this.handleLoadMoreBtnClick = null;
		this.pubSub = options.pubSub || ProjectUtil.pubSub; // default to pubSub in options
		//this.bindings();
		//this.listeners();
		this.postInitialize(options);
		this.renderPage = true;
		this.trigger('initialize');
		// this will be applied to all promos extending this view
		//Override this event Object in a child promo view
		this.viewEvents = {};
	}

	baseEvents() {
		return {
			'change .select-filter': 'handleSelectFilterChange', // select has changed
			'click #load-more-btn': 'handleLoadMoreBtnClick', // handle 'more' button click
			//'click .filter-btn': 'handleFilterBtnClick', // show/hide filtering panel
			'click #prev-page-btn': 'handlePrevPageBtnClick', // handle 'prev' button click
			'click #next-page-btn': 'handleNextPageBtnClick', // handle 'next' button click
			'change .alpha-checkbox': 'handleAlphaFilterChange', // handle alpha flitering click
			'click .alpha-checkbox:checked': 'handleDeselectAlphaFilter',
			'change .filter-checkbox input[type=checkbox]': 'handleCheckboxFilterChange', // handle fliter checkbox click
			'change .filter-radio input[type=radio]': 'handleCheckboxFilterChange', // handle fliter checkbox click
			'input #filter-search': 'handleSearchInputChange', // show/hide clear search button
			'click .clear-search-btn': 'handleClearSearchBtnClick', // clear the search field and executue API
			'submit #filter-search-form': 'handleFilterSearchFormSubmit', // handle search form submission
			'click .filter-close-btn': 'handleFilterCloseBtnClick',
		};
	}

	// merge base and promo events
	events() {
		return _.extend({}, this.baseEvents(), this.viewEvents());
	}

	listeners() {
		this.listenTo(this.pubSub, 'updateQsFilters', this.handleUpdateQsFilters, this);
		// add child view listeners
		this.childViewListeners();
	}

	// override as necessary for child-view-specific listeners
	childViewListeners() {

	}

	async postRender() {
		var self = this;

		// make sure the template is set - not using render() here
		await this.setTemplate();
		// define standard filter module items
		this.$html = $('html');
		this.$filterContainer = $('.filter-container', this.$el);
		this.$searchField = $('#filter-search', this.$el);
		this.$closeBtn = $('.filter-close-btn', this.$el);
		this.$clearSearchBtn = $('.clear-search-btn', this.$el);
		// load more button
		this.$loadMoreBtn = $('#load-more-btn', this.$el);
		this.$loadPrevBtn = $('#prev-page-btn', this.$el);
		this.$loadNextBtn = $('#next-page-btn', this.$el);
		this.$selectLabel = $('.select-label', this.$el); // alpha 'select' label

		this.renderOnTemplatesLoaded = false;
		this.lastSearchVal = '';
		this.showingClearSearchBtn = false;
		this.imgType = this.$el.data('img-type');
		this.loader = new LoaderView({ model: new Backbone.Model({ pageLoader: false }), el: $('.loader-container', this.$el) }).render();
		//window.loader = this.loader;
		// get reference to this module data for filtering
		this.siteData = this.model.get('site');

		this.loadOnUpdate = true;
		this.useQuerystring = true;
		this.usePagination = false;

		// for handling updates / animations
		this.loadMoreBtnTween = null;
		this.updatingFiltersForQsChange = false;
		this.replaceContent = true; // start true to replace skeleton template
		// default curPage - will be overwritten in handleUpdateQsFilters if necessary
		this.curPage = 1;

		// an Object provided to pass params to render function
		this.renderParamsObj = {};

		// additional view-specific postRender actions
		this.postRenderView();

		// TODO: ADD SELECT LISTENERS IN LISTENERS FUNCTION

		// initiate the first api call
		if (this.useQuerystring) {
			this.handleUpdateQsFilters(true);
		} else {
			this.startUpdateFilters(this.getRequestData(), true);
		}

		// clear ProjectUtil value so it doesn't show up in additional indexes
		ProjectUtil.internalSearchVal = '';

		return self;
	}

	/**
	 * View-specific post-render actions.  Define this.listTemplate and this.apiCall here for sure.
	 */
	postRenderView() { }

	/**
	 * Allow select listners to be handled seperately by child views
	 */
	handleSelectFilterChange() {
		/*
		var self = this;
		// listen for events
		this.$selectFilters.on('change', function () {
			if (!self.updatingFiltersForQsChange) {
				if (self.loadOnUpdate) {
					self.updateContent(true); // true because we are replacing existing content
				}
			}
		});
		*/
		this.updateContent(true); // true because we are replacing existing content
	}

	/**
	 * Get the value of the alpha filters
	 */
	getAlphaFilterVal() {
		//check each checkbox:checked, and add to an array
		var $checked = $('input.alpha-checkbox:checked'),
			resultsAr;
		if ($checked.length) {
			resultsAr = [];
			_.each($checked, function (checkbox) {
				resultsAr.push($(checkbox).val());
			});
			// update stored reference to this.currentAlphaInputId
			this.currentAlphaInputId = $checked.prop('id');
			return resultsAr;
		} else {
			// clear stored reference to this.currentAlphaInputId
			this.currentAlphaInputId = null;
			return '';
		}
	}

	/**
	 * get Array of values for a set of checkbox filters
	 */
	getCheckboxFilterValues(tFilterName) {
		var checked = $('input[type=checkbox][name=' + tFilterName + ']:checked').get(),
			resultsAr = [];

		if (checked.length) {
			// collect data-value for checked checkboxes
			_.each(checked, function (tEl) {
				//resultsAr.push($(tEl).data('value'));
				resultsAr.push($(tEl).data('id'));
			});
		}
		return resultsAr.join('|');
	}

	/**
	 * Set checkbox values when querystring changes
	 */
	setCheckboxFilterValues(tFilterName, tFilterVal) {
		var $filter = $('input[type=checkbox][name=' + tFilterName + ']'),
			tFilterValAr = tFilterVal ? tFilterVal.split('|') : [];
		// set everything to off
		$filter.prop('checked', false);
		// set value from tFilterVal to checked
		_.each(tFilterValAr, function (tVal) {
			$filter.filter('[data-id="' + tVal + '"]').prop('checked', 'checked');
		});
	}

	/**
	 * get Array of values for a selectize field 
	 */
	getSelectFilterValues(tFilterName, tDeliniator) {
		var selectedAr = $('#' + tFilterName).val();
		// handle single selects
		if (typeof selectedAr === 'string') {
			return selectedAr;
		}
		// handle multiple selects
		if (Array.isArray(selectedAr)) {
			// set a default value of '|' for tDeliniator if not provided
			tDeliniator = tDeliniator || '|';
			//selectedAr = selectedAr.join('|');
			if (selectedAr.length > 1 && selectedAr[0] === '') {
				selectedAr.shift();
			}
			return selectedAr.join(tDeliniator);
		}
		return null;
	}

	/**
	 * Get the value of a text input, replacing spaces with '+'
	 */
	getTextInputValue(tFilterName) {
		const $el = $('#' + tFilterName);
		if ($el.length) {
			return $el.val().toLowerCase().split(' ').join('+');
		}
		return '';
	}

	/**
	 * Set select values when querystring changes
	 */
	setSelectFilterValues(tFilterName, tFilterVal) {
		var tFilterValAr = tFilterVal ? tFilterVal.split('|') : [],
			$tSelect = $('#' + tFilterName);
		tFilterVal = tFilterVal || '';
		// set the active value in $tSelect
		_.each(tFilterValAr, function (item) {
			$tSelect.find('option[value="' + item + '"]').prop('selected', true);
		});

		//tSelectize.setValue(tFilterValAr);// selectize API call // pass true for 'silent' to avoid triggering change event
		//$('#' + tFilterName).trigger('change'); // trigger change event so stuff happens
		//this.$('#' + tFilterName + '-selectized').html(tFilterVal);
	}

	/**
	 * get radio value
	 */
	getRadioFilterValue(tFilterName) {
		var checked = $('input[type=radio][name=' + tFilterName + ']:checked').get(),
			resultsAr = [];

		if (checked.length) {
			// collect data-value for checked checkboxes
			_.each(checked, function (tEl) {
				//resultsAr.push($(tEl).data('value'));
				resultsAr.push($(tEl).data('id'));
			});
		}
		return resultsAr.join('|');
	}

	/**
	 * set radio value
	 */
	setRadioFilterValues(tFilterName, tFilterVal) {
		var $filter = $('input[type=radio][name=' + tFilterName + ']'),
			tFilterValAr = tFilterVal ? tFilterVal.split('|') : [];
		// set everything to off
		$filter.prop('checked', false);
		// set value from tFilterVal to checked
		_.each(tFilterValAr, function (tVal) {
			$filter.filter('[data-id="' + tVal + '"]').prop('checked', 'checked');
		});
	}

	/**
	 * Build the querystring for updating the url.  This should be defined per view.
	 */
	buildQueryString() { }

	/**
	 * Get the value of a querystring, return as String.
	 */
	getQueryString(tQs) {
		var qs = ProjectUtil.getQueryString(tQs);
		if (qs === '') {
			return undefined;
		}
		return qs;
	}

	/**
	 * Get the data Object for the API request.  This should be defined per view.
	 */
	getRequestData() { return {}; }

	/**
	 * 
	 */
	startUpdateFilters(tData, tReplace) {
		var self = this;
		// UPDATE SELECT/CHECKBOXES TO MATCH QUERYSTRING WITHOUT TRIGGERING A NEW PAGE REQUEST
		this.updatingFiltersForQsChange = true;
		// update checkboxes/selects here
		ProjectUtil.onNextFrame(function () {
			self.updateFilters(tData, tReplace);
			// move this to getContent
			/*ProjectUtil.onNextFrame(function () {
				// allow filter changes to make a new page reuqest.
				self.updatingFiltersForQsChange = false;
			});*/
		});
	}

	/**
	 * Update the actual display of the filters.  This should be defined per view.
	 */
	updateFilters(tData, tReplace) {
		this.childUpdateFilters(tData, tReplace);
		this.updateFiltersComplete(tData, tReplace);
	}

	updateFiltersComplete(tData, tReplace) {
		// two paths: 
		if (this.replaceContent || tReplace) {
			// hide content, show loader + start load
			this.hideContent(tData, true);
			// show loader
			this.loader.showLoader();
			// hide 'more' button
			if (this.$loadMoreBtn) {
				// hide 'more' button
				this.$loadMoreBtn.addClass('disabled');
				if (this.loadMoreBtnTween) {
					this.loadMoreBtnTween.kill();
				}
				this.loadMoreBtnTween = gsap.to(this.$loadMoreBtn, { duration: 1, autoAlpha: 0, ease: 'quad.inOut' });
			}
		} else {
			// show loader + start load
			this.getContent(tData, false);
		}
	}

	/**
	 * Hide existing content - it will be replaced
	 */
	hideContent(tData, tReplace) {
		var self = this;
		gsap.to(this.$itemListDest, {
			duration: 0.2,
			opacity: 0, ease: 'quad.inOut', onComplete() {
				self.getContent(tData, tReplace);
			}
		});
	}

	/**
	 * Handle content recieved from API request
	 */
	handleGetContent(tAction, response) {
		console.log("[BaseFilterView].handleGetContent", tAction, response);
		var self = this;
		if (this.template !== undefined) {
			// hide loader
			self.loader.closeLoader();
			// render new content
			self.renderContent(tAction, response);
			// hide loader
			// reveal content
			gsap.to(self.$itemListDest, { duration: 0.2, opacity: 1, ease: 'quad.inOut' });

			self.updateMoreBtn(response);

			// update pagination buttons
			self.updatePaginationBtns(response);

			// allow child views to use this content at this point
			self.childGetContent(response);

			// update lazyload / scrollReveal
			ProjectUtil.onNextFrame(function () {
				//ProjectUtil.lazyLoader.update();
				self.pubSub.trigger('scrollRevealRefresh', { updateList: true });
			}, self);
			this.renderAction = null;
			this.renderResponse = null;

		} else {
			this.renderAction = tAction;
			this.renderResponse = response;
			this.renderOnTemplatesLoaded = true;
		}
	}

	/**
	 * Render the content.  This allows child views to extend this functionality.
	 */
	renderContent(tAction, response) {
		this.$itemListDest[tAction](this.template($.extend({}, this.renderParamsObj, { site: this.siteData, theme_img: this.imgType }, response.data)));
	}

	/**
	 * Show / hide the 'more' button, depending on nextPage value.  This allows child views to extend this functionality.
	 */
	updateMoreBtn(response) {
		var self = this;
		// show more button - depending on nextPage
		if (response?.data?.results?.nextPage !== 0) {
			// there is more content, reveal button appropriately
			if (self.$loadMoreBtn) {
				self.$loadMoreBtn.removeClass('loading disabled');

				if (self.loadMoreBtnTween) {
					self.loadMoreBtnTween.kill();
				}
				ProjectUtil.onNextFrame(function () {
					self.loadMoreBtnTween = gsap.to(self.$loadMoreBtn, { duration: 0.2, delay: 0.2, autoAlpha: 1, ease: 'quad.inOut' });
				});
			}
			if (self.$loadNextBtn) {
				self.$loadNextBtn.removeClass('loading disabled');
			}
		} else {
			// there is no more content, hide button
			if (self.$loadMoreBtn) {
				self.$loadMoreBtn.removeClass('loading disabled');
				if (self.loadMoreBtnTween) {
					self.loadMoreBtnTween.kill();
				}
				ProjectUtil.onNextFrame(function () {
					self.loadMoreBtnTween = gsap.to(self.$loadMoreBtn, { duration: 0.2, autoAlpha: 0, ease: 'quad.inOut' });
				});
			}
			if (self.$loadNextBtn) {
				self.$loadNextBtn.removeClass('loading'); // leave it disabled
			}
		}
		if (self.$loadPrevBtn) {
			if (this.curPage > 1) {
				self.$loadPrevBtn.removeClass('loading disabled');
			} else {
				self.$loadPrevBtn.removeClass('loading'); // leave it disabled
			}
		}
	}

	/**
	 * Enable/disable pagination buttons based on response data
	 */
	updatePaginationBtns(response) {
		console.log("[BaseFilterView].updatePaginationBtns", response);
		if (this.$loadPrevBtn) {
			if (response?.data?.results?.prevPage !== 0) {
				this.$loadPrevBtn.attr('aria-disabled', false).prop('disabled', false);
			} else {
				this.$loadPrevBtn.attr('aria-disabled', true).prop('disabled', true);
			}
		}
		if (this.$loadNextBtn) {
			if (response?.data?.results?.nextPage !== 0) {
				this.$loadNextBtn.attr('aria-disabled', false).prop('disabled', false);
			} else {
				this.$loadNextBtn.attr('aria-disabled', true).prop('disabled', true);
			}
		}
	}

	/**
	 * Allow child views to perform additional actions with content.
	 */
	childGetContent(/*tData*/) { }

	/**
	 * Get the new content
	 */
	getContent(tData, tReplace) {
		console.log("[BaseFilterView].getContent", tData, tReplace);
		var self = this,
			tAction = tReplace ? 'html' : 'append';
		// make API request
		// ex. /api/?a=posts&vision=866|867&depts=877
		ProjectUtil.requestAPI('a=' + this.apiCall,
			tData,
			function (response) {
				//validate response
				if (response?.data?.status === 'ok') {
					// handle response
					self.handleGetContent(tAction, response);
				} else {
					// handle error
					console.warn("[BaseFilterView].getContent::requestAPI.success, status !== 'ok': ", response);
				}
			},
			function () {
				// hide loader
				self.loader.closeLoader();
				// show error message?

				// hide button?
				console.warn("[BaseFilterView].getContent::requestAPI.fail");
			}
		);
		ProjectUtil.onNextFrame(function () {
			// allow filter changes to make a new page reuqest.
			self.updatingFiltersForQsChange = false;
		});
	}

	/**
	 * Collect filter values and request API
	 */
	updateContent(tReplace) {
		// if this is a filter update due to a querystring change, then break this process.
		if (this.updatingFiltersForQsChange) {
			return;
		}
		// note if content is being replaced or appended.
		this.replaceContent = tReplace;

		if (this.replaceContent && this.useQuerystring) {
			// change the url with the new querystring
			this.pubSub.trigger('pageChangeRequest', Backbone.history.getFragment().split('?')[0] + this.buildQueryString());
		} else {
			// just get the content with the exsitng querystring - pnum will increment
			this.handleUpdateQsFilters(this.replaceContent);
		}
		this.replaceContent = false;
	}

	/**
	 * If we are waiting for templates to load, they're ready now, so render
	 */
	handleTemplatesLoaded() {
		if (this.renderOnTemplatesLoaded) {
			this.handleGetContent(this.renderAction, this.renderResponse);
		}
	}

	/**
	 * Load more posts click - update pnum and request more data
	 */
	handleLoadMoreBtnClick(e) {
		if ($(e.currentTarget).hasClass('disabled')) {
			return;
		}
		this.updateContent(false); // false because we are appending content
		// update button
		this.$loadMoreBtn.addClass('loading disabled');
	}

	/**
	 * Handle 'prev' button click - update pnum and request previous page data.  Set this.$loadPrevBtn and this.$loadNextBtn to disabled.
	 */
	handlePrevPageBtnClick(e) {
		if ($(e.currentTarget).hasClass('disabled')) {
			return;
		}
		if (this.curPage > 1) {
			this.curPage--;
			this.updateContent(false); // false because this is not a new filter
			this.$loadPrevBtn.addClass('loading disabled');
			this.$loadNextBtn.addClass('disabled');
		}
	}

	/**
	 * Handle 'next' button click - update pnum and request next page data.  Set this.$loadPrevBtn and this.$loadNextBtn to disabled
	 */
	handleNextPageBtnClick(e) {
		if ($(e.currentTarget).hasClass('disabled')) {
			return;
		}
		this.curPage++;
		this.updateContent(false); // false because this is not a new filter
		this.$loadPrevBtn.addClass('disabled');
		this.$loadNextBtn.addClass('loading disabled');
	}


	/**
	 * Show/hide the filters
	 */
	/*handleFilterBtnClick(e) {
		var self = this;
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		this.$filterContainer.toggleClass('show').removeClass('initial');
		this.$html.toggleClass('filter-show');
		// scroll to position?
		if (!window.viewportGTE(1400)) { // TODO: Evaluate size
			if (this.el.getBoundingClientRect().top > 0) {
				ProjectUtil.animateToElTop(this.el, { padding: 0 });
				// set focus on the close button
				self.$closeBtn.focus();
			}
		}
	}*/

	handleAlphaFilterChange(e) {
		if (e) {
			e.preventDefault();
			e.stopPropagation();
		}
		$('.alpha-checkbox:checked').not(e.currentTarget).prop('checked', false).attr('aria-checked', false);
		$('e.currentTarget').prop('checked', true).attr('aria-checked', true);

		// content update
		this.updateContent(true); // true because we are replacing existing content
		//this.handleUpdateQsFilters();
	}

	handleDeselectAlphaFilter(e) {
		// is this the stored reference?
		if (this.currentAlphaInputId === $(e.currentTarget).prop('id')) {
			// get the clicked item and de-check it
			$(e.currentTarget).prop('checked', false).attr('aria-checked', false);
			// content update
			this.updateContent(true); // true because we are replacing existing content
			//this.handleUpdateQsFilters();
		}
	}

	handleCheckboxFilterChange() {
		if (this.loadOnUpdate) {
			this.updateContent(true); // true because we are replacing existing content
		}
	}

	/**
	 * When input changes, show/hide the clear button
	 */
	handleSearchInputChange() {
		var tVal = this.$searchField.val();

		if (!tVal || tVal === '') {
			if (this.showingClearSearchBtn) {
				this.showingClearSearchBtn = false;
				// hide the clear button
				this.$clearSearchBtn.removeClass('showing');
			}
			return;
		}
		// show the clear button
		if (!this.showingClearSearchBtn) {
			this.showingClearSearchBtn = true;
			// show it now
			this.$clearSearchBtn.addClass('showing');
		}
	}

	/**
	 * Clear search and query new results
	 */
	handleClearSearchBtnClick(e) {
		e.preventDefault();
		e.stopPropagation();

		// clear search
		this.$searchField.val('');
		// trigger input handler
		this.handleSearchInputChange();
		// new query - only if search is actually updated
		if (this.lastSearchVal !== '') {
			this.handleUpdateQsFilters(true);
		}
	}

	handleFilterSearchFormSubmit(e) {
		e.preventDefault();
		e.stopPropagation();

		if (this.loadOnUpdate) {
			//this.updateContent(true); // true because we are replacing existing content // leave search out of querystring
			this.handleUpdateQsFilters(true);
		}
	}

	handleFilterCloseBtnClick() {
		this.$filterContainer.removeClass('show');
		this.$html.removeClass('filter-show');
	}

	/**
	 * Handle querystring filter update event.
	 */
	handleUpdateQsFilters(tReplace) {
		if (this.usePagination) {
			if (tReplace) {
				// this is a new filter
				this.curPage = 1;
			} else {
				// this is tha same filter, just a new page
				// this.curPage has already been set in the button click handler
			}
			tReplace = true; // force this, content will be replaced regardless of action when using pagination
		} else {
			// update curPage
			this.curPage = this.replaceContent || tReplace ? 1 : this.curPage + 1;
		}
		// get request params
		const tData = this.getRequestData();
		this.lastSearchVal = tData.search;
		// update checkboxes/selects to match querystring
		this.startUpdateFilters(tData, tReplace);
	}

	/**
	 * Clean up child-view specific elements. This should be defined per view.
	 */
	childCleanup() {

	}

	cleanup() {

		this.childCleanup();
	}

}

export default BaseFilterView;

